module.exports = __webpack_public_path__ + "static/06-c832e0b8f908b171a9813f7fdb2dac83.jpg";